import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { SearchMode } from '../searcher/searcher.component';
import { Toggler } from 'projects/exi-ui/src/lib/utils/toggler.class';
import { Fade } from 'projects/exi-ui/src/lib/animations/animations';
import { Options } from '../options/options.component';
import { of } from 'rxjs';
import { FocusOut } from 'projects/exi-ui/src/lib/utils/focusOut.class';
import { Tag } from '../../table/utility/context/local/filter.class';

const modes: SearchMode[] = ['start', 'end', 'includes', 'euqals'];


@Component({
   selector: 'app-tag',
   template: `
      <section class="wrapper" #Wrapper>
         <button  class="tag {{ tag.mode }}" 
                  [disabled]="disabled"
                  (click)="toggler.toggle()"
                  (blur)="focusOut.handler($event)">
            <div class="title">{{ tag.title }}</div>
            <button  [icons]="'CRL:DELETE'" 
                     class="delete" 
                     (click)="delete(tag)" 
                     [disabled]="disabled"></button>
         </button>
         <app-options [ctx]="modes" *ngIf="toggler.isOpened" class="modes" @Fade></app-options>
      </section>
   `,
   styleUrls: ['./tag.component.scss'],
   animations: [ Fade ]
})
export class TagComponent<D extends object> implements OnInit, AfterViewInit {
   @ViewChild('Wrapper') wrapper: ElementRef<HTMLElement>;
   @Input() tag: Tag;
   @Input() disabled: boolean;
   @Output() onDelete = new EventEmitter<D>();
   @Output() onModeChange = new EventEmitter<SearchMode>();

   public toggler = new Toggler();
   public focusOut: FocusOut;
   public modes: Options<SearchMode>;

   ngOnInit() {
      
   }

   ngAfterViewInit() {
      this.focusOut = new FocusOut({
         host: this.wrapper.nativeElement,
         callback: () => null//this.toggler.close()
      });
      
      this.modes = {
         title: mode => mode,
         stream: of(modes),
         style: 'colors',
         onBlur: this.focusOut.handler,
         select: mode => {
            this.tag.mode = mode;
            this.toggler.close();
            this.onModeChange.emit(mode);
         },
      };
   }

   public delete(tag: D) {
      this.onDelete.emit(tag);
   }

}

